import { useEffect, useState } from "react";
import DisplayProgressions from "./DisplayProgressions";
import ProgressionSelect from "./ProgressionSelect";
import { exibeProgressaoPredefinidaNaTela } from "../utils/escalas";
import { presetProgressions } from "../data/presetProgressions";

export default function PresetProgressionsPage() {
  const [progressaoSelecionada, setProgressaoSelecionada] = useState(presetProgressions[0].id);
  const [chords, setChords] = useState([]);

  useEffect(() => {
    setChords(exibeProgressaoPredefinidaNaTela(progressaoSelecionada));
  }, [progressaoSelecionada]);

  return (
    <div className="flex flex-col gap-6 md:flex-row">
      <div className="p-4 bg-white rounded shadow-sm w-full md:w-1/3">
        <ProgressionSelect
          options={presetProgressions.map((progressao) => ({
            label: progressao.label,
            value: progressao.id,
          }))}
          onChange={setProgressaoSelecionada}
          label="Selecione uma progressão pronta:"
          className="text-white"
        />
      </div>
      <DisplayProgressions chordsApp={chords} />
    </div>
  );
}
